// extracted by mini-css-extract-plugin
export default {"Comments":"Comments_Comments__WDKsg"};